module.exports = __webpack_public_path__ + "img/empty.b6b4fafc.png";